import { render, staticRenderFns } from "./Recommend.vue?vue&type=template&id=780f1d71&"
import script from "./Recommend.vue?vue&type=script&lang=ts&"
export * from "./Recommend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports